import { memo } from "react"

const IconBackToTop = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
      <rect width="60" height="60" rx="30" fill="#DCD9FF" />
      <path
        d="M24.0003 46.0003H36.0003L36.0003 30.0003H45.6803L30.0003 14.3203L14.3203 30.0003H24.0003L24.0003 46.0003Z"
        fill="#002C98"
      />
    </svg>
  )
}

export default memo(IconBackToTop)
